// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nh2B","colMin":"styles_colMin__1hB2b"};